import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { GraduationCap, CircleNotch } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.hash.replace(/^#/, ""));
    const sessionId = params.get("session_id");
    (async () => {
      try {
        await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        navigate("/dashboard", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#1E293B] text-white">
      <div className="text-center">
        <div className="inline-flex items-center rounded-md bg-white px-3 py-2 mb-5">
          <img src="/novacert.png" alt="NovaCert" className="h-7 w-auto object-contain" />
        </div>
        <CircleNotch size={28} className="animate-spin text-primary mx-auto mb-3" />
        <p className="font-display font-700">Iniciando sesión…</p>
      </div>
    </div>
  );
}
